import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DomSanitizer } from '@angular/platform-browser';
import { TrelloService } from 'src/app/shared/services/trello.service';

@Component({
	selector: 'app-card',
	templateUrl: './card.component.html',
	styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {

	@Input() card: any = {
		"id": "67730c46234bb6c3d535eaa5",
		"badges": {
			"attachmentsByType": {
				"trello": {
					"board": 0,
					"card": 0
				}
			},
			"externalSource": null,
			"location": false,
			"votes": 0,
			"viewingMemberVoted": false,
			"subscribed": true,
			"attachments": 0,
			"fogbugz": "",
			"checkItems": 0,
			"checkItemsChecked": 0,
			"checkItemsEarliestDue": null,
			"comments": 1,
			"description": true,
			"due": null,
			"dueComplete": false,
			"lastUpdatedByAi": false,
			"start": null
		},
		"checkItemStates": [],
		"closed": false,
		"dueComplete": false,
		"dateLastActivity": "2024-12-30T21:12:21.816Z",
		"desc": "**Context**: Alexandra Wathen is unable to access Teams after acquiring a new phone.\n\n**Steps**:\n\n- Confirm account details for Alexandra Wathen.\n- Reset her password.\n- Provide her with the updated credentials.\n- Ensure successful login after resetting.",
		"descData": {
			"emoji": {}
		},
		"due": null,
		"dueReminder": null,
		"email": null,
		"idBoard": "67505cd5dc84a733a10157ad",
		"idChecklists": [],
		"idList": "67505cd5dc84a733a10157b4",
		"idMembers": [],
		"idMembersVoted": [],
		"idShort": 23,
		"idAttachmentCover": null,
		"labels": [],
		"idLabels": [],
		"manualCoverAttachment": false,
		"name": "Reset Alexandra Wathen's Password for Teams",
		"pinned": false,
		"pos": 16448,
		"shortLink": "FFsaX1qd",
		"shortUrl": "https://trello.com/c/FFsaX1qd",
		"start": null,
		"subscribed": true,
		"url": "https://trello.com/c/FFsaX1qd/23-reset-alexandra-wathens-password-for-teams",
		"cover": {
			"idAttachment": null,
			"color": null,
			"idUploadedBackground": null,
			"size": "normal",
			"brightness": "dark",
			"idPlugin": null
		},
		"isTemplate": false,
		"cardRole": null
	}

	comments: any[] = [];
	checklists: any[] = [];

	constructor(
		public modalCtrl: ModalController,
		private sanitizer: DomSanitizer,
		private trelloService: TrelloService
	) { }

	ngOnInit() {
		console.log(this.card);
		// if (this.card.idChecklists && this.card.idChecklists.length > 0) {
		// 	this.card.idChecklists.forEach((checklistId: string) => {
		// 		// this.loadChecklist(checklistId);
		// 	});
		// }
		this.loadCardComments();
	}

	loadCardComments() {
		if (this.card.id) {
			this.trelloService.getCardComments(this.card.id).subscribe((comments) => {
				this.comments = comments;
				console.log('Comments:', this.comments);
			});
		}
	}

	// loadChecklist(checklistId: string) {
	// 	this.trelloService.getChecklistById(checklistId).subscribe((checklist) => {
	// 		console.log('checklist', checklist);
	// 		this.checklists.push(checklist);
	// 	});
	// 	this.checklists.sort((a, b) => b.pos - a.pos);
	// }
}
